// Local translations
export const T = {
  en_GB: {
    document: "Document",
    uploading: "Uploading...",
    helpText: "Upload PDF, Word, Excel, ODS, CSV or TXT (max 10MB).",
    currentFile: "Uploaded file",
    linkLabel: "Link Label",
    linkLabelPlaceholder: "Download methodology guide",
    linkLabelHint: "Text shown on the download link (defaults to the file name)",
    invalidFileType: "Please upload a PDF, Word, Excel, ODS, CSV or TXT document",
    fileTooLarge: "File size must be less than 10MB",
    uploadFailed: "Failed to upload document. Please try again.",
  },
  nb_NO: {
    document: "Dokument",
    uploading: "Laster opp...",
    helpText: "Last opp PDF, Word, Excel, ODS, CSV eller TXT (maks 10MB).",
    currentFile: "Opplastet fil",
    linkLabel: "Lenketekst",
    linkLabelPlaceholder: "Last ned metodedokument",
    linkLabelHint: "Tekst som vises på nedlastingslenken (standard er filnavnet)",
    invalidFileType: "Vennligst last opp et PDF, Word, Excel, ODS, CSV eller TXT-dokument",
    fileTooLarge: "Filstørrelsen må være mindre enn 10MB",
    uploadFailed: "Kunne ikke laste opp dokumentet. Vennligst prøv igjen.",
  },
} as const;
